import React, { useEffect, useRef, useContext, useState } from "react";
import SectionTitle from "../../components/section-title";
import Button from "../../components/button";
import ButtonCustom from "../../components/button-custom";
import LoanForm from "../../components/calculators-form/emi-calc";
import PropTypes from "prop-types";
import { FontSizeContext } from "../../context/fontSizeContext";
import { Link } from "react-router-dom";

const EMICalcContainer = ({ contRef, classOption = "section-pb" }) => {
    const { fontSize } = useContext(FontSizeContext);
    const textRefs = useRef([]);
    const [defaultSizes, setDefaultSizes] = useState([]);

    const adjustFontSize = (change) => {
        textRefs.current.forEach((element, index) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                const currentSize = parseFloat(computedStyle.fontSize);
                const newSize = currentSize + change;
                element.style.fontSize = `${newSize}px`;
            }
        });
    };

    const resetFontSize = () => {
        textRefs.current.forEach((element, index) => {
            if (element && defaultSizes[index] !== null) {
                element.style.fontSize = `${defaultSizes[index]}px`;
            }
        });
    };

    useEffect(() => {
        if (fontSize == 0) {
            resetFontSize();
        } else {
            adjustFontSize(fontSize);
        }
    }, [fontSize]);

    useEffect(() => {
        const sizes = textRefs.current.map((element) => {
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                return parseFloat(computedStyle.fontSize);
            }
            return null;
        });
        setDefaultSizes(sizes);
    }, []);

    return (
        <div
            className={`banner-section service-section position-relative ${classOption}`}
            ref={contRef}
        >
            <div
                className="container p-3"
                style={{
                    borderTop: "solid darkgray",
                }}
            >
                <div className="col-md-12 col-xl-12 mb-10 text-center">
                    <div className="col-md-12 mt-5">
                        <h3 className="title">
                            <h1 className="text-primary">
                                <b>EMI Calculator</b>
                            </h1>
                        </h3>
                    </div>
                </div>

                <div className="m-auto col-md-12 col-xl-12 ">
                    <LoanForm></LoanForm>
                </div>
                {/* <hr></hr> */}
                <div className=" col-md-12 col-xl-12 mb-7 ">
                    <h5 className="title text-primary">1. What is an EMI?</h5>
                    <p className="ms-3 text-dark">
                        EMI stands for <b>Equated Monthly Installment</b>. In
                        simple words, it is the amount that you repay to the
                        financial institution on a monthly basis. This amount is
                        calculated based on the loan amount, rate of interest,
                        and tenure of the loan. At NeoGrowth we understand each
                        business is unique and to suite your business
                        requirement we provide multiple repayment frequency
                        options; daily / weekly / fortnightly and monthly.
                    </p>
                </div>
                <div className=" col-md-12 col-xl-12 mb-7 ">
                    <h5 className="title text-primary">
                        2. What is an EMI Calculator for Business Loan?
                    </h5>
                    <p className="ms-3 text-dark">
                        NeoGrowth’s Business Loan EMI calculator helps you
                        calculate daily and monthly payments on your business
                        loan.The calculator help you determine the amount you
                        need to pay, helping you to opt loan amount that matches
                        your short-term requirement. Thus helping you facilitate
                        your working capital planning.
                    </p>
                </div>
                <div className=" col-md-12 col-xl-12 mb-7 ">
                    <h5 className="title text-primary">
                        3. How to calculate your EMI using an unsecured Business
                        Loans Calculator?
                    </h5>
                    <p className="ms-3 text-dark">
                        A business loan calculator is simple to use. You need to
                        enter the loan amount, tenure (monthly) and rate of
                        interest and you will know how much amount you need to
                        repay.
                    </p>
                </div>
                <div className=" col-md-12 col-xl-12 mb-7 ">
                    <p className="" style={{ fontSize: "13px" }}>
                        <b>Disclaimer</b>: The calculator on this website only
                        provide indicative results based on the inputs provided
                        by you. They are only used for a conceptual explanation,
                        indicative/illustrative results and are not to be
                        construed as suggesting, implying, or inferring any
                        future results. Results received from these calculators
                        are designed for comparative purposes only and NeoGrowth
                        Credit Private Limited does not guarantee the accuracy
                        of any information available on this site, and is not
                        responsible for any errors, omissions, or
                        misrepresentations. The default figures shown are
                        hypothetical and may not be applicable to your
                        individual situation. The calculator do not qualify you
                        for a loan. Qualification for a loan may require
                        additional information which is not gathered in this
                        calculator. Information under the calculator such as
                        interest rates, pricing, taxes, stamp duty, EMI
                        payments, etc. are estimates and are subject to change
                        at any time and should be used for comparison only.
                    </p>
                    <p className="" style={{ fontSize: "13px" }}>
                        <i>
                            <span style={{ color: "red" }}>* </span>All prices
                            are indicative and subject to NeoGrowth’s sole
                            discretion
                        </i>
                    </p>
                </div>

                {/* <div className="row col-md-12 col-xl-3 mb-7 text-center">
                    <ButtonCustom
                        text="<b>GST<br>Calculator</b>"
                        path="/job-opening"
                        ImagePath="/images/career/icon/gst.svg"
                    />
                </div> */}
                <hr></hr>
                <div className="row col-md-12 col-xl-12 mb-7 text-center">
                    <div className="col-md-6 col-6">
                        <Button
                            classOption="btn btn-sm btn-primary btn-hover-primary"
                            text="GST Calculator"
                            link="https://calculator.neogrowth.in/GST-Calculator"
                        />
                    </div>
                    <div className="col-md-6 col-6">
                        <Button
                            classOption="btn btn-sm btn-primary btn-hover-primary"
                            text="Gratuity Calculator"
                            link="https://calculator.neogrowth.in/Gratuity-Calculator"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

EMICalcContainer.propTypes = {
    classOption: PropTypes.string,
    contRef: PropTypes.string,
};

export default EMICalcContainer;
